export default {
  ONLINE: 1,
  SCHEDULED: 2,
};
